import { createContext } from 'react';

export type VerificationIntent = 'quote' | 'contact' | 'careers';

export interface VerificationOptions {
    intent?: VerificationIntent;
    forceFresh?: boolean;
}

export interface VerificationContextType {
    turnstileToken: string | null;
    quoteVerificationSession: string | null;
    quoteVerificationExpiresAt: number | null;
    resetToken: () => void;
    resetQuoteVerificationSession: () => void;
    prepareQuoteVerification: () => void;
    verify: (options?: VerificationOptions) => Promise<boolean>;
    verifyToken: (options?: VerificationOptions) => Promise<string | null>;
    ensureQuoteVerificationSession: (options?: { forceFresh?: boolean }) => Promise<boolean>;
    getQuoteVerificationSession: (options?: { forceFresh?: boolean }) => Promise<string | null>;
    isVerifying: boolean;
}

export const VerificationContext = createContext<VerificationContextType | undefined>(undefined);
